@let qrCodeData = qrCodeData$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="more"></ion-back-button>
    </ion-buttons>
    <ion-title>Share Contact Info</ion-title>
  </ion-toolbar>
</red-header-content>
<red-page-content [scrollX]="false" [scrollY]="false">
  @if (qrCodeData) {
  <div class="tw:flex tw:h-full tw:w-full tw:flex-col tw:items-center tw:justify-center">
    <div class="tw:p-4 tw:text-center tw:text-xl">
      <ion-text color="primary">Scan vCard:</ion-text>
    </div>
    <qrcode
      class="tw:flex tw:w-full tw:items-center tw:justify-center"
      [qrdata]="qrCodeData || ''"
      [elementType]="'canvas'"
      [errorCorrectionLevel]="'H'"
      [margin]="2"
      [scale]="1"
      [width]="300"
    ></qrcode>
    <div class="tw:p-4 tw:text-center tw:text-xs">
      <ion-text color="medium">
        Use the camera on another phone to add the vCard contact information to the phonebook.
      </ion-text>
    </div>
  </div>
  }
</red-page-content>
